/**
 * Formats a date string or Date object to Romanian convention: dd-MM-yyyy
 * @param {string|Date} dateInput - The date to format
 * @returns {string} Formatted date string in dd-MM-yyyy format, or empty string if invalid
 */
const formatDateRo = (dateInput) => {
  if (!dateInput) return '';
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

export default formatDateRo;
